import { render, staticRenderFns } from "./BtnInput.vue?vue&type=template&id=4a40c81e&scoped=true"
import script from "./BtnInput.vue?vue&type=script&lang=js"
export * from "./BtnInput.vue?vue&type=script&lang=js"
import style0 from "./BtnInput.vue?vue&type=style&index=0&id=4a40c81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40c81e",
  null
  
)

export default component.exports